import { createContext } from 'react';
import { ScopeStore } from '../recoil';

export const recoilScopeContext = createContext<ScopeStore>({});
